export default {
  ucfirst(string) {
    return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
  },
  randomString(
    length,
    chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
  ) {
    var result = "";
    for (var i = length; i > 0; --i)
      result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  },
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};



// WEBPACK FOOTER //
// ./src/helpers/helpers.js